import { render, staticRenderFns } from "./DirectPlacementGoals.vue?vue&type=template&id=424b4ad0"
import script from "./DirectPlacementGoals.vue?vue&type=script&lang=js"
export * from "./DirectPlacementGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports